import { useForm, ValidationError } from '@formspree/react';

export default function ContactForm() {
  const [state, handleSubmit] = useForm('mleyrnle');

  if (state.succeeded) {
    return <p>Thanks for joining!</p>;
  }

  return (
    <form method="POST" onSubmit={handleSubmit}>
      <div className='ContactForm'>
      <label htmlFor="name">Nome</label>
      <input id="name" type="text" name="name" required />
      <ValidationError prefix="Name" field="name" errors={state.errors} />

      <label htmlFor="email">Email</label>
      <input id="email" type="email" name="email" required />
      <ValidationError prefix="Email" field="email" errors={state.errors} />

      <button type="submit" disabled={state.submitting}>
        Submit
      </button>
      <ValidationError errors={state.errors} />
      </div>
    </form>
  );
}